import { ListItemButton } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import type { ListItemButtonProps } from '@mui/material';

export interface RootLinkStyleProps extends ListItemButtonProps {
  active: boolean;
}

const PADDING = 2.5;

export const StyledListItemButton = styled(
  ListItemButton,
  { shouldForwardProp: (prop) => prop !== 'active' }
)<RootLinkStyleProps>(
  ( { active = false, theme } ) => (
    {
      ...theme.typography.body2,
      height: 48,
      textTransform: 'capitalize',
      justifyContent: 'center',
      paddingLeft: theme.spacing(PADDING),
      paddingRight: theme.spacing(PADDING),
      color: theme.palette.text.secondary,
      ...active && {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      }
      ,
    }
  )
);
